import React from "react";
import { ToastContainer } from "react-toastify";

import AppProvider from "./hooks/AppProvider";
import { HeartbeatProvider } from "./Context/HeartbeatContext";
import Routes from "./routes";

import "antd/dist/antd.variable.css";
import "./styles/global.scss";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <AppProvider>
      <HeartbeatProvider>
        <ToastContainer />
        <Routes />
      </HeartbeatProvider>
    </AppProvider>
  );
}

export default App;
